import { Navigate } from 'react-router-dom';

const MODULE_ROUTES = [
    { module: 'flow_messages', path: '/flow_messages' },
    { module: 'messaging',     path: '/messaging' },
    ...(window.SHOW_SMART_TALKING ? [{ module: 'smart_talking', path: '/smart_talking' }] : []),
    { module: 'campaigns',     path: '/campaigns' },
    { module: 'admin',         path: '/admin' },
    { module: 'integracion',   path: '/integracion' },
    { module: 'stats',         path: '/stats' },
];

const getFirstRoute = () => {
    const cookies = document.cookie.split('; ');

    const perfilCookie = cookies.find(c => c.startsWith('perfil='));
    const perfil = perfilCookie ? decodeURIComponent(perfilCookie.split('=')[1]) : '';
    if (perfil === 'Super-Admin') return '/flow_messages';

    const modulesCookie = cookies.find(c => c.startsWith('modules='));
    if (!modulesCookie) return '/error_no_auth';

    const modules = decodeURIComponent(modulesCookie.split('=')[1]).split(',').map(s => s.trim()).filter(Boolean);
    const match = MODULE_ROUTES.find(r => modules.includes(r.module));
    return match ? match.path : '/error_no_auth';
};

const HomePage = () => <Navigate to={getFirstRoute()} replace />;

export default HomePage;
